<template>
  <div class="mb-4">
    <h2><slot></slot></h2>
    <p class="mt-3 mr-3" v-if="$slots.description">
      <slot name="description"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style scoped></style>
